/* eslint-env browser */

import React from 'react';
import { render } from 'react-dom';
import Footer from './Footer';

const {
  footerData
} = window.APP_STATE;

export default props =>
  render(
    <Footer footerData={footerData} {...props} />, document.getElementById('footer'));

export { Footer };



// WEBPACK FOOTER //
// ./src/modules/footer/client.js